import set from '@department-of-veterans-affairs/platform-forms-system/set';
import { createSaveInProgressFormReducer } from '@department-of-veterans-affairs/platform-forms/reducers';
import formConfig from '../config/form';

import {
  CLEAR_FORM_DATA,
  CLOSE_REVIEW_CHAPTER,
  FETCH_INQUIRIES_FAILURE,
  FETCH_INQUIRIES_STARTED,
  FETCH_INQUIRIES_SUCCESS,
  OPEN_REVIEW_CHAPTER,
  SET_UPDATED_IN_REVIEW,
  SET_VA_HEALTH_FACILITY,
} from '../actions';

export const initialReduxState = {
  updatedInReview: '',
  vaHealthFacility: '',
  reviewPageView: {
    openChapters: [],
  },
  inquiriesHistory: {
    status: 'idle', // 'idle' | 'loading' | 'success' | 'error'
    fetchedAt: null,
    results: [],
  },
};

export default {
  form: createSaveInProgressFormReducer(formConfig),
  test: 'test',
  askVA: (state = initialReduxState, action) => {
    switch (action.type) {
      case CLEAR_FORM_DATA:
        return {
          ...initialReduxState,
        };
      case SET_UPDATED_IN_REVIEW:
        return {
          ...state,
          updatedInReview: action.payload,
        };
      case OPEN_REVIEW_CHAPTER: {
        const openChapters = [
          ...state.reviewPageView.openChapters,
          action.openedChapter,
        ];

        return set('reviewPageView.openChapters', openChapters, state);
      }
      case CLOSE_REVIEW_CHAPTER: {
        const openChapters = state.reviewPageView.openChapters.filter(
          value => value !== action.closedChapter,
        );

        const newState = set(
          'reviewPageView.openChapters',
          openChapters,
          state,
        );

        const viewedPages = new Set(state.reviewPageView.viewedPages);

        action.pageKeys.forEach(pageKey => viewedPages.add(pageKey));

        return set('reviewPageView.viewedPages', viewedPages, newState);
      }
      case SET_VA_HEALTH_FACILITY:
        return {
          ...state,
          vaHealthFacility: action.payload,
        };
      case FETCH_INQUIRIES_STARTED:
        return {
          ...state,
          inquiriesHistory: {
            ...state.inquiriesHistory,
            status: 'loading',
          },
        };
      case FETCH_INQUIRIES_SUCCESS:
        return {
          ...state,
          inquiriesHistory: {
            status: 'success',
            fetchedAt: action.fetchedAt,
            results: action.payload,
          },
        };
      case FETCH_INQUIRIES_FAILURE:
        return {
          ...state,
          inquiriesHistory: {
            ...state.inquiriesHistory,
            status: 'error',
          },
        };
      default:
        return state;
    }
  },
};
